const cardItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20school%20romance%2C%20young%20couple%20in%20school%20uniform%20under%20cherry%20blossom%20tree%2C%20soft%20warm%20pink%20and%20coral%20color%20palette%2C%20digital%20illustration%2C%20clean%20composition%2C%20simple%20background&width=400&height=560&seq=card-manhwa-01&orientation=portrait',
    title: '秘密恋爱',
    author: '朴敏雅',
    genre: '校园恋爱',
    status: '连载中',
    update: '今日更新',
    rating: '9.8',
    desc: '青梅竹马十年后重逢，隐藏身份的秘密恋爱就此展开。细腻画风描绘青春心动瞬间。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20adventure%2C%20warrior%20with%20magical%20sword%20standing%20on%20cliff%2C%20warm%20orange%20and%20gold%20sunset%20background%2C%20digital%20illustration%2C%20epic%20composition%2C%20simple%20background&width=400&height=560&seq=card-manhwa-02&orientation=portrait',
    title: '剑与魔法',
    author: '金俊秀',
    genre: '奇幻冒险',
    status: '连载中',
    update: '昨日更新',
    rating: '9.6',
    desc: '普通高中生穿越异世界，手握传说之剑开启冒险旅程。宏大世界观与燃炸战斗场面。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20mystery%20thriller%2C%20detective%20character%20in%20trench%20coat%20in%20rainy%20alley%2C%20noir%20atmosphere%2C%20warm%20amber%20streetlight%2C%20digital%20illustration%2C%20simple%20background&width=400&height=560&seq=card-manhwa-03&orientation=portrait',
    title: '暗夜追凶',
    author: '李贤宇',
    genre: '悬疑推理',
    status: '连载中',
    update: '本周更新',
    rating: '9.5',
    desc: '退休刑警重拾旧案，层层剥茧揭露连环凶案背后的惊人阴谋，每话悬念拉满。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20office%20comedy%2C%20young%20woman%20in%20business%20suit%20with%20coffee%2C%20bright%20modern%20office%20background%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20digital%20illustration%2C%20clean%20composition&width=400&height=560&seq=card-manhwa-04&orientation=portrait',
    title: '职场生存记',
    author: '崔恩智',
    genre: '都市职场',
    status: '连载中',
    update: '今日更新',
    rating: '9.3',
    desc: '新人社员的爆笑入职故事，真实还原韩国职场文化与办公室人际关系。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20romantic%20fantasy%2C%20princess%20in%20elegant%20dress%20with%20crown%2C%20royal%20palace%20background%2C%20warm%20golden%20lighting%2C%20digital%20illustration%2C%20luxurious%20atmosphere%2C%20simple%20composition&width=400&height=560&seq=card-manhwa-05&orientation=portrait',
    title: '恶役千金物语',
    author: '韩素希',
    genre: '恋爱奇幻',
    status: '连载中',
    update: '昨日更新',
    rating: '9.2',
    desc: '转生为反派千金后，以智慧和魅力改写悲惨命运，甜虐交织的逆袭之路。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%2C%20demon%20character%20with%20red%20eyes%20and%20dark%20hair%2C%20gothic%20cathedral%20background%2C%20deep%20crimson%20and%20black%20color%20palette%2C%20digital%20illustration%2C%20dramatic%20lighting&width=400&height=560&seq=card-manhwa-06&orientation=portrait',
    title: '恶魔契约',
    author: '张泰浩',
    genre: '黑暗奇幻',
    status: '已完结',
    update: '全集可读',
    rating: '9.0',
    desc: '为拯救家人与恶魔签订契约的少年，一步步走向深渊。正篇完结，番外连载中。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20medical%20fantasy%2C%20young%20pharmacist%20with%20herbs%20and%20potions%2C%20apothecary%20shop%20background%2C%20warm%20amber%20and%20sage%20green%20color%20palette%2C%20digital%20illustration%2C%20cozy%20atmosphere&width=400&height=560&seq=card-manhwa-07&orientation=portrait',
    title: '异世界药局',
    author: '李瑞元',
    genre: '医疗奇幻',
    status: '连载中',
    update: '新作上线',
    rating: '8.8',
    desc: '天才药师穿越到医疗落后的异世界，用现代医学知识拯救生命。治愈系新作。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">推荐韩漫</h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              布丁漫画编辑精选热门韩漫，每日更新不容错过
            </p>
          </div>
          <a
            href="#index"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.img}
                  alt={`布丁漫画推荐韩漫 — ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded-full bg-background-50/90 text-primary-600 whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
                {item.status === '已完结' && (
                  <div className="absolute top-2 right-2">
                    <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500/90 text-background-50 whitespace-nowrap">
                      完结
                    </span>
                  </div>
                )}
              </div>
              <div className="p-3 flex flex-col flex-1">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-1">{item.title}</h3>
                <div className="mt-1 flex items-center gap-1.5 text-xs text-foreground-400 flex-wrap">
                  <span>{item.author}</span>
                  <span>·</span>
                  <span>{item.genre}</span>
                </div>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed flex-1">{item.desc}</p>
                <div className="mt-2 pt-2 border-t border-background-200/50">
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap">{item.update}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}